import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseDataService, BaseTabsUpdateComponent, TabsContainerService, UserService } from 'yt-ng-framework';
import { KomitentUgovor } from './komitent-ugovor';

@Component({
  selector: 'yt-komitent-ugovor-tab-update',
  templateUrl: './komitent-ugovor-tab-update.component.html'
})
export class KomitentUgovorTabUpdateComponent extends BaseTabsUpdateComponent<KomitentUgovor> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<KomitentUgovor>,
    protected baseDataService: BaseDataService,
    protected userService: UserService
  ) { 
    super(activatedRoute, tabsContainerService, baseDataService, userService)
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
